import React from "react";
import "../Footer/Footer.css";
import { BiMailSend } from "react-icons/bi";
import { FiMail } from "react-icons/fi";
import { MdOutlineLocationOn } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";
import { SlSocialFacebook } from "react-icons/sl";
import { BsWhatsapp, BsInstagram } from "react-icons/bs";
import { FaXTwitter } from "react-icons/fa6";
import Logo from "../../Images/logo/logo.png";
import { Link, NavLink } from "react-router-dom";
import { FaYoutube } from "react-icons/fa";
import Eventsdata from "../../Data/Eventsdata";

const Footer = () => {
  return (
    <>
      <section className="Footer-Section bg-blak">
        <div className="container">
          <div className="Footer-Section-con">
            <div className="row">
              <div className="col-md-3">
                <div className="Footer-Logo-and-social-con">
                  <div className="Footer-Logo-con">
                    <div className="Footer-Logo">
                      <NavLink to='/'>
                      <img src={Logo} alt="logog"/>
                      </NavLink>
                    </div>
                  </div>
                  <div className="Footer-Para" style={{width:'70%'}}>
                    <p style={{textAlign:'justify'}}>
                    With your family, Seema's Resort offers the best place to decompress and rejuvenate.
                    </p>
                  </div>
                  <div className="Footer-Social-Con">
                    <div className="Footer-Social">
                      <a href="tel:7745852323">
                        <IoCallOutline />
                      </a>
                    </div>
                    <div className="Footer-Social">
                      <a
                        href="https://wa.me/7745852323"
                        target="blank"
                      >
                        <BsWhatsapp />
                      </a>
                    </div>
                    <div className="Footer-Social">
                      <a href="https://www.instagram.com/seemas_resort/?igsh=MXFqaGl6cTd3OG0xZA%3D%3D" target="blank">
                        <BsInstagram />
                      </a>
                    </div>
                    <div className="Footer-Social">
                      <a
                        href="mailto:seemaresort@gmail.com"
                        target="blank"
                      >
                        <FiMail />
                      </a>
                    </div>
                    <div className="Footer-Social">
                      <a
                        href="https://www.facebook.com/Seemaresort?mibextid=ZbWKwL"
                        target="blank"
                      >
                        <SlSocialFacebook />
                      </a>
                    </div>
                    {/* <div className="Footer-Social">
                      <a href="https://www.youtube.com/@maskebrothers1" target="blank">
                        <FaYoutube />
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="Footer-Quick-Link-con">
                  <h2>Events</h2>
                  <ul>
                    {Eventsdata.map((data)=>(
                      <li>
                      <Link to={data.slugs}>{data.name}</Link>
                    </li>
                    
                    ))}
                    
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="Footer-Quick-Link-con">
                  <h2>Quick Link</h2>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/top-resort-neral">About Us</Link>
                    </li>
                    {/* <li>
                      <Link to="/why-us">Why Us</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/blog">Blog</Link>
                    </li> */}
                    <li>
                      <Link to="/resort-with-rooms-neral">Rooms</Link>
                    </li>
                    <li>
                      <Link to="/wedding-lawn-neral">Events</Link>
                    </li>
                    <li>
                      <Link to="/family-resort-neral">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/best-resort-neral">Attractions</Link>
                    </li>
                    <li>
                      <Link to="/resort-near-neral">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3">
                <div className="Footer-contact-Details-con">
                  <div className="Footer-contact-Details-head">
                    <h2>Talk To Us</h2>
                  </div>
                  <div className="Footer-contact-Details-call">
                    <a>
                      <IoCallOutline />
                      <div className="Footer-contact">
                        <h2>
                          <a href="tel:7745852323">7745852323</a>
                        </h2>
                      </div>
                    </a>
                    <a href="mailto:seemaresort@gmail.com">
                      <BiMailSend />
                      <h2>seemaresort@gmail.com</h2>
                    </a>
                    <a
                      href=""
                      target="blank"
                    >
                      <MdOutlineLocationOn />
                      <h2>
                      Karjat - Neral Rd, near panchawati, opp. dignity foundation, Neral, Jite, Maharashtra 410101                      </h2>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Footer-Section-Copy-con">
          
          <h3>Copyright © 2024, All Right Reserved [ Seema's Resort ]</h3>
          <h2 className="my-2">
            Designed By &nbsp; 
            <a href="https://skdm.in/" target="blank">
               Shree Krishna Digital Marketing.
            </a>
          </h2>
        </div>
      </section>
    </>
  );
};

export default Footer;
